import { ButtonV2, ButtonV2Props, useAGGWrapperContext } from '@fsg/gui-bits'
import { Rotate } from '@fsg/icons'

export function ResetFilters({ children, ...buttonProps }: ButtonV2Props) {
  const { gridRef } = useAGGWrapperContext()
  const gridApi = gridRef.current?.api

  function handleResetFilter() {
    if (!gridApi) throw new Error('Grid API is not ready')
    gridApi.setFilterModel(null)
  }

  return (
    <ButtonV2
      type="button"
      className="border-blue-600 font-bold text-blue-600"
      variant="secondary"
      size="md"
      onClick={handleResetFilter}
      {...buttonProps}
    >
      <Rotate className="scale-x-[-1]" />
      {children ?? 'Reset Filters'}
    </ButtonV2>
  )
}
